
import * as THREE from "three";
import { MathUtils, Float32BufferAttribute, Skeleton } from "three";
import { ThreeUtils } from "./ThreeUtils";

class Utils {


    public static rotatePointY(x, y, alpha) {
        var p = [0, 0];
        p[0] = x * Math.cos(alpha) - y * Math.sin(alpha);
        p[1] = x * Math.sin(alpha) + y * Math.cos(alpha);
        return p;
    }

    public static norm(x, y) {
        var b = Math.sqrt(x * x + y * y);
        return [x / b, y / b];
    }




    // berechnet Einfügepunkt für Licht und Möbel
    public static calcRoomInsertPoint(walls) {
        var x = 0; var z = 0;
        if (walls.length < 6) {
            var minx = Infinity; var minz = Infinity;
            var maxx = 0; var maxz = 0;
            for (var i = 0; i < walls.length; i++) {
                if (walls[i].p1.x > maxx) maxx = walls[i].p1.x;
                if (walls[i].p1.z > maxz) maxz = walls[i].p1.z;
                if (walls[i].p1.x < minx) minx = walls[i].p1.x;
                if (walls[i].p1.z < minz) minz = walls[i].p1.z;
            }
            x = minx + (maxx - minx) / 2;
            z = minz + (maxz - minz) / 2;

        }

        if (walls.length === 6) {
            var wallsx = []; var maxxp1 = { x: 0, z: 0 }; var maxzp1 = { x: 0, z: 0 }; var maxxl = 0;
            var wallsz = []; var maxxp2 = { x: 0, z: 0 }; var maxzp2 = { x: 0, z: 0 }; var maxzl = 0;
            for (var i = 0; i < walls.length; i++) {
                if (walls[i].p1.x === walls[i].p2.x) wallsx.push(walls[i].p2.x);
                if (walls[i].p1.z === walls[i].p2.z) wallsz.push(walls[i].p2.z);
                if (Math.abs(walls[i].p2.x - walls[i].p1.x) > maxxl) {
                    maxxl = Math.abs(walls[i].p2.x - walls[i].p1.x);
                    maxxp1 = { x: walls[i].p1.x, z: walls[i].p1.z };
                    maxxp2 = { x: walls[i].p2.x, z: walls[i].p2.z };
                }
                if (Math.abs(walls[i].p2.z - walls[i].p1.z) > maxzl) {
                    maxzl = Math.abs(walls[i].p2.z - walls[i].p1.z);
                    maxzp1 = { x: walls[i].p1.x, z: walls[i].p1.z };
                    maxzp2 = { x: walls[i].p2.x, z: walls[i].p2.z };
                }

            }
            wallsx = wallsx.sort(function (a, b) {
                return a - b;
            });

            wallsz = wallsz.sort(function (a, b) {
                return a - b;
            });

            var xm = wallsx[1];
            var zm = wallsz[1];
            // => pmitte , aus beide längsten folgt paussen ==> x,z
            var xl = 0; var zl = 0;
            if (maxxp1.x == maxzp1.x) xl = maxxp1.x;
            if (maxxp1.x == maxzp2.x) xl = maxxp1.x;
            if (maxxp2.x == maxzp1.x) xl = maxxp2.x;
            if (maxxp2.x == maxzp2.x) xl = maxxp2.x;

            if (maxxp1.z == maxzp1.z) zl = maxxp1.z;
            if (maxxp1.z == maxzp2.z) zl = maxxp1.z;
            if (maxxp2.z == maxzp1.z) zl = maxxp2.z;
            if (maxxp2.z == maxzp2.z) zl = maxxp2.z;

            x = xl + (xm - xl) / 2;
            z = zl + (zm - zl) / 2;

        }

        return { x: x, y: 0, z: z };
    }

    // berechnet den Punkt auf der Wand für Verschiebung Fenster/Tuer
    public static mousewallprojection(mousepos: THREE.Vector2, p1: THREE.Vector2, p2: THREE.Vector2): THREE.Vector2 {

        var s = mousepos.sub(p1);
        var p = p2.sub(p1);

        var dp = p.dot(s);
        var cosalpha = dp / (s.length() * p.length())
        // console.log('s,p ', s, p, cosalpha)
        var alpha = Math.acos(cosalpha);
        var tlength = s.length() * Math.cos(alpha);

        var pn = p.normalize();
        //     console.log('project', mousepos, p1, 'alpha, l', alpha, tlength)

        var t = pn.multiplyScalar(tlength);
        t.add(p1)
        return t;
    }


    public static wallnormal(wall) {
        var v21z = (-wall.p2.x + wall.p1.x)
        var v21x = (-wall.p2.z + wall.p1.z)
        var n = Utils.norm(v21x, v21z);
        var nr = Utils.rotatePointY(n[0], n[1], -Math.PI / 2);
        // nr[0] *= 3; // Tiefe
        // nr[1] *= 3;
        return nr;
        //  shape.lineTo(-wall.p2.z - nr[0], wall.p2.x + nr[1]);
    }

    // berechnet Einfügepunkt auf Wand, wenn Wand voll, wird die nächse genommen
    public static calcWallInsertPoint(walls, gltf, isWindow = false, interiors, index = 0) {
        var width = gltf.userData.interior.width;
        if (gltf.userData.width)
            width = gltf.userData.width;


        var bb = ThreeUtils.getBBox(gltf);
        var x = 0;
        var z = 0;
        var y = 0;

        var wallindex = index;

        for (var i = wallindex; i < walls.length; i++) {
            try {

                var wall = walls[i];
                wallindex = i;

                var v21z = (-wall.p2.x + wall.p1.x);
                var v21x = (-wall.p2.z + wall.p1.z);
                var wvec = new THREE.Vector2(v21x, v21z);
                var nvec = wvec.normalize();
                var dwvec = nvec.multiplyScalar(width / 2 * 1.1);

                var n = Utils.norm(v21x, v21z);
                var nr = Utils.rotatePointY(n[0], n[1], -Math.PI / 2);
                var angle = -new THREE.Vector2(n[0], n[1]).angle();

                var xpos = -wall.p1.z + nr[0] * 20 + v21x / 2;
                var zpos = -(wall.p1.x - nr[1] * 20 - v21z / 2);

                //                var xpos = -wall.p1.z + nr[0] * 20 + dwvec.x; // + v21x / 2;
                //                var zpos = -(wall.p1.x - nr[1] * 20 - dwvec.y); // - v21z / 2);

                // todo:check for collision, sonst nächste Wand
                var colllision = false;
                if (!colllision) break;

            } catch (ex) {
                console.log('wall', i, wallindex)
                console.log('ex', ex);
                return null;
            }
        }


        //console.log('calcwallinserted', x, z, y, angle, wallindex);

        if (isWindow) y = 100;
        return { x: xpos, y: y, z: zpos, wall: wallindex, rot: angle };
    }


    public static calcWallRotation(wall) {
        var v21z = (-wall.p2.x + wall.p1.x);
        var v21x = (-wall.p2.z + wall.p1.z);

        var n = Utils.norm(v21x, v21z);
        var nr = Utils.rotatePointY(n[0], n[1], -Math.PI / 2);
        var angle = -new THREE.Vector2(n[0], n[1]).angle();

        return angle;
    }





    public static async isUrlFound(url) {
        try {
            const response = await fetch(url, {
                method: 'HEAD',
                cache: 'no-cache'
            });
            console.log(response.status);
            return response.status === 200;

        } catch (error) {
            console.log('test', error);
            return false;
        }

    }

    public static inside(point, vs) {
        // ray-casting algorithm based on
        // https://wrf.ecse.rpi.edu/Research/Short_Notes/pnpoly.html/pnpoly.html

        var x = point[0], y = point[1];

        var inside = false;
        for (var i = 0, j = vs.length - 1; i < vs.length; j = i++) {
            var xi = vs[i][0], yi = vs[i][1];
            var xj = vs[j][0], yj = vs[j][1];

            var intersect = ((yi > y) != (yj > y))
                && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
            if (intersect) inside = !inside;
        }

        return inside;
    }

}


export { Utils };

